import { Button, Card, CardMedia, Divider, useTheme } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { NoRecordsFound } from 'framework/components/NoRecordsFound';
import { SearchbarWithParams } from 'framework/components/search/SearchbarWithParams';
import { useQueryContext } from 'framework/hooks/useQueryContext';
import { PageableTableWithColumnSelection } from 'framework/table/PageableTableWithColumnSelection';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { IStockMovement, IStockMovementsFilterParams, StockMovementExportProp, StockMovementExportProps, stockMovementsQuery_export } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { ExportButtonMenuAndDialog } from 'shared/export/ExportButtonMenuAndDialog';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { RestrictedContent } from 'shared/layout/RestrictedContent';
import { SelectColumnsButtonAndDialog } from 'shared/selectColumns/SelectColumnsButtonAndDialog';
import { createDetailsNavigateHeader } from 'shared/table/createDetailsNavigateHeader';
import { calcStockMovementDetailRoute } from '../../../routes';
import { StockMovementsQueryContext } from './StockMovementsQueryContext';
import { StockMovementsListViewContext } from './StockMovementsListViewContext';
import { StockMovementsFilter } from './StockMovementsFilter';
import { StockMovementForm } from '../forms/StockMovementForm';
import { StockMovementsSelectableColumn } from './StockMovementsSelectableColumn';

export const StockMovementsListPage = ({ reloadTrigger }: IReloadTriggerProps) => {
	const strings = useLocalization();
	const theme = useTheme();
	const { params, setParams, queryResult, reload } = useQueryContext(StockMovementsQueryContext, reloadTrigger);
	const { columns, columnsRecord, setColumns, exportRecord, headers } = useContext(StockMovementsListViewContext);
	const { push } = useHistory();
	const { open, confirm, cancel } = useDialogsContext(reload);

	if (queryResult === undefined) {
		return <div></div>;
	}

	const onNew = () => {
		open(
			<StockMovementForm
				open
				confirm={onConfirmNew}
				cancel={cancel}
			/>
		);
	};

	const onConfirmNew = (id: string) => {
		confirm();
		push(calcStockMovementDetailRoute(id));
	};

	return (
		<RestrictedContent pageClaim='StockMovements'>
			<div className='df-row-ac jc-sb'>
				<SearchbarWithParams
					params={params}
					setParams={setParams}
					placeholder={strings.searchVerb}
					style={{ width: '400px' }}
					variant='paper'
				/>
				<Button
					variant='contained'
					color='primary'
					startIcon={<AddIcon />}
					onClick={onNew}>
					{strings.new}
				</Button>
			</div>
			{queryResult.unfilteredCount > 0 && (
				<>
					<Card>
						<div className='df-row jc-sb'>
							<StockMovementsFilter
								params={params}
								onFilter={params => setParams(onResetToPage1(params))}
								paddingLeft={theme.spacing(1.5)}
							/>
							<div
								className='df-row-ac'
								style={{ paddingRight: theme.spacing(1.5) }}>
								<ExportButtonMenuAndDialog<IStockMovementsFilterParams, StockMovementExportProp>
									params={params}
									filteredCount={queryResult.filteredCount}
									unfilteredCount={queryResult.unfilteredCount}
									allProps={StockMovementExportProps}
									downloadF={stockMovementsQuery_export}
									fileName='stock_bewegingen'
									record={exportRecord}
									view='stockMovements'
								/>
								<SelectColumnsButtonAndDialog
									selectedColumns={columns}
									setSelectedColumns={setColumns}
									record={columnsRecord}
									view='stockMovements'
								/>
							</div>
						</div>
						<Divider />
						<CardMedia>
							<PageableTableWithColumnSelection<IStockMovement, StockMovementsSelectableColumn>
								queryResult={queryResult}
								headers={headers}
								sortParams={params.sortParams}
								pageParams={params.pageParams}
								setParams={(sp, pp) => setParams({ ...params, sortParams: sp, pageParams: pp })}
								getKey={inst => inst.id}
								selectedColumns={columns}
								appendColumn={createDetailsNavigateHeader<IStockMovement>(calcStockMovementDetailRoute)}
							/>
						</CardMedia>
					</Card>
				</>
			)}
			{queryResult.unfilteredCount === 0 && <NoRecordsFound>{strings.noWhatDefined(strings.stockMovements)}</NoRecordsFound>}
		</RestrictedContent>
	);
};
